import gql from 'graphql-tag';
import { CAMPAIGN_SAVED_TEMPLATE_FIELDS } from './campaignSavedTemplate.fragment';

export const SET_POST_MALONE_SAVED_TEMPLATE_CATEGORIES_MUTATION = gql`
  mutation SetPostMaloneSavedTemplateCategoriesMutation(
    $campaignId: ID!
    $postMaloneSavedTemplateId: ID!
    $categoryIds: [ID!]!
  ) {
    setPostMaloneSavedTemplateCategories(
      campaignId: $campaignId
      postMaloneSavedTemplateId: $postMaloneSavedTemplateId
      categoryIds: $categoryIds
    ) {
      campaignSavedTemplate {
        ...CampaignSavedTemplateFields
      }
      errors
    }
  }
  ${CAMPAIGN_SAVED_TEMPLATE_FIELDS}
`;
